(() => {
  if (window.trialWorksReady) return;
  window.trialWorksReady = true;
  document.addEventListener('click', e => {
    const link = e.target.closest('.tw-mobile-menu a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.querySelectorAll('.tw-mobile-menu[open]').forEach(menu => {menu.open=false;menu.querySelector('summary').focus();});
  });
  const init = root => {
    root.querySelectorAll('.tw-enquiry-form').forEach(form => {
      if (form.dataset.enhanced || !form.querySelector('[data-tw-step]')) return;
      form.dataset.enhanced = 'true';
      const steps = [...form.querySelectorAll('[data-tw-step]')];
      const back = form.querySelector('.tw-form-back');
      const next = form.querySelector('.tw-form-next');
      const submit = form.querySelector('.tw-form-submit');
      const status = form.querySelector('[data-tw-step-status]');
      const indicators = [...form.closest('.tw-enquiry').querySelectorAll('[data-tw-indicator]')];
      let current = 0;
      form.noValidate = true;
      const show = (index, focus=true) => {
        current=index;
        steps.forEach((step,i) => {step.hidden=i!==index;});
        indicators.forEach((item,i) => {if(i===index)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');});
        back.hidden=index===0;next.hidden=index===steps.length-1;submit.hidden=index!==steps.length-1;
        status.textContent=`${index+1} / ${steps.length}`;
        if(focus){const legend=steps[index].querySelector('legend');legend.tabIndex=-1;legend.focus();}
      };
      const firstInvalid = step => [...step.querySelectorAll('input,select,textarea')].find(field=>!field.checkValidity());
      next.addEventListener('click', () => {const invalid=firstInvalid(steps[current]);if(invalid){invalid.reportValidity();return;}show(current+1);});
      back.addEventListener('click', () => show(Math.max(0,current-1)));
      form.addEventListener('submit', e => {
        for(let i=0;i<steps.length;i++){const invalid=firstInvalid(steps[i]);if(invalid){e.preventDefault();show(i,false);invalid.reportValidity();return;}}
        if(current<steps.length-1){e.preventDefault();show(current+1);}
      });
      // Recover the appropriate step when a merchant selects a field in Theme Editor.
      document.addEventListener('shopify:block:select', e => {const step=e.target.closest('[data-tw-step]');if(step&&form.contains(step))show(steps.indexOf(step));});
      show(0,false);
      const serverErrors=form.querySelector('.tw-server-errors');if(serverErrors)serverErrors.focus();
    });
    root.querySelectorAll('.tw-form-success').forEach(el=>el.focus());
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('tw-reveal');observer.unobserve(entry.target);}}),{threshold:.08});
      root.querySelectorAll('.tw-science-grid article,.tw-card').forEach(el=>observer.observe(el));
    }
  };
  init(document);
  document.addEventListener('shopify:section:load', e=>init(e.target));
})();

